<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <div class="section white-panel pt24 pb8 mb16">
          <p class="text-center mb16"><img src="lib/images/ic_done_1.svg" alt=""></p>
          <p class="fs16 font-weight-bold text-center line-height1_7">店舗に予約内容を通知しました<br>
          店舗より日程調整のお電話をさせて頂きます</p>
        </div>

        <div class="section white-panel pt20 ml16 mr16">
          <p class="fs13 line-height1_6">機種変更や端末紛失の際は、車検をご予約のSSまで電話にてご連絡下さい。</p>
          <h2 class="fs13 font-weight-bold mb4">{{ ssInfo.ss_name }}</h2>
          <table class="table w100p fs14 line-height1_2">
            <tbody>
              <tr>
                <th class="font-weight-normal color-font2 va-top pt8 w25p">電話番号</th>
                <td class="va-top pt8 pl8"><a v-on:click="calling()" class="color-green2">{{ ssInfo.tel }}</a></td>
              </tr>
              <tr v-if="ssInfo.opening_hours_weekday || ssInfo.opening_hours_saturday || ssInfo.opening_hours_sunday || ssInfo.opening_hours_holiday">
                <th class="font-weight-normal color-font2 va-top pt8">営業時間</th>
                <td class="va-top pt8 pl8">
                  <template v-if="ssInfo.opening_hours_weekday">平日 {{ ssInfo.opening_hours_weekday }}<br></template>
                  <template v-if="ssInfo.opening_hours_saturday">土曜 {{ ssInfo.opening_hours_saturday }}<br></template>
                  <template v-if="ssInfo.opening_hours_sunday">日曜 {{ ssInfo.opening_hours_sunday }}<br></template>
                  <template v-if="ssInfo.opening_hours_holiday">祝日 {{ ssInfo.opening_hours_holiday }}</template></td>
              </tr>
              <tr v-if="ssInfo.opening_hours_carcare">
                <th class="font-weight-normal color-font2 va-top pt8">カーケア<br>営業時間</th>
                <td class="va-top pt8 pl8">{{ ssInfo.opening_hours_carcare }}</td>
              </tr>
              <tr v-if="ssInfo.regular_holiday">
                <th class="font-weight-normal color-font2 va-top pt8">定休日</th>
                <td class="va-top pt8 pl8">{{ ssInfo.regular_holiday }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="section transparent-panel">
          <router-link :to="{ name: 'CarCareTop', query: { tsid: nativeData.tsid, popinfoid: nativeData.popinfoid, otoken: nativeData.otoken }}" style="text-decoration: none;" v-on:click.native="eventTrackStartCarcare()">
            <button class="button fs16 mt8 mb16 pd16 radius200 w80p">カーケアトップに戻る</button>
          </router-link>
        </div>
      </article>
    </div>
  </div>
</template>

<script>

export default {
  methods: {
    eventTrackStartCarcare () {
      this.nativeEVENTSet('ShakenKanryouButton', 'MOVED_CARCARE', 'TAP')
    },
    calling () {
      this.nativeEVENTSet('ShakenKanryouButton', 'TEL_BUTTON', 'TAP')
      window.location.href = 'tel:' + this.ssInfo.tel
    }
  },
  props: [
    'ssInfo',
    'nativeData'
  ],
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(false)
    this.nativePVset('SHAKEN_YOYAKU_KANRYOU')
  }
}
</script>
